import { render, staticRenderFns } from "./mascot.vue?vue&type=template&id=29d6b704"
import script from "./mascot.vue?vue&type=script&lang=js"
export * from "./mascot.vue?vue&type=script&lang=js"
import style0 from "./mascot.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/mascot.vue
// module id = isJO
// module chunks = 0